import React, {Component, Fragment} from 'react';
import autobind from 'autobind-decorator'
import { connect } from "react-redux";
import {setActiveDate, setActiveDateIndex, setActiveDateType, setHoverDateIndex, setStandardDate} from "../../../actions/statistics/statisticsActions";
import * as InitStatus from "../../../constants/common/InitializationStatus";
import AmCharts from "@amcharts/amcharts3-react";
import moment from "moment";
import If from "../../common/control/If";


@connect(state => ({
  standardDate: state.statistics.standardDate,
  activeDate: state.statistics.activeDate,
  activeDateType: state.statistics.activeDateType,
  hoverDateIndex: state.statistics.hoverDateIndex,
  activeDateIndex: state.statistics.activeDateIndex,
}), dispatch => ({
  handleSetStandardDate(standardDate) {
    dispatch(setStandardDate(standardDate))
  },
  // 활성화된 날짜 변경
  handleSetActiveDate(activeDate) {
    dispatch(setActiveDate(activeDate))
  },
  // 활성화된 날짜 타입 변경 (day, week, month)
  handleSetActiveDateType(activeDateType) {
    dispatch(setActiveDateType(activeDateType))
  },
  // 선택된 날짜의 Index
  handleSetActiveDateIndex(activeDateIndex) {
    dispatch(setActiveDateIndex(activeDateIndex))
  },
  // hover된 날짜의 Index
  handleSetHoverDateIndex(hoverDateIndex) {
    dispatch(setHoverDateIndex(hoverDateIndex))
  }
}))
class GraphColumn extends Component {
  constructor(props) {
    super(props);

    this.chartList = ["amcharts-graph-searchChart", "amcharts-graph-snsChart", "amcharts-graph-etcChart"];
    this.chart = null;
    this.rootChart = null;
    this.defaultFormat = "YYYY-MM-DD";
  }


  componentDidMount() {
    this.props.config.listeners = [{  // 그래프 클릭 이벤트
      event: "clickGraphItem", method: (e) => {
        this.changeActiveCategory(e.index, true);
      }
    }, { // 애니메이션 종료 이벤트
      event: "animationFinished", method: (e) => {
        this.animationFinished(e);
      }
    }, { // 액션 변화 이벤트 (hover)
      event: "changed", method: (e) => {
        this.graphDataChangeEvent(e);
      }
    }, { // 최초 init 이벤트
      event: "init", method: (e) => {
        this.rootChart = e.chart;
      }
    }];
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.checkTrendApiChanged(prevProps)) {
      this.animateAgain();
    }

    if (this.props.mouseLeaveEvent && this.checkMouseLeave()) {
      this.changeStyleAndCursor(this.props.activeDateIndex);
    }


    if (this.checkChangeGrapItemStyle(prevProps)) {
      const {hoverDateIndex} = this.props;
      this.changeGraphItemStyle(hoverDateIndex, "over");
      const date = this.getTimestampByIndex(hoverDateIndex);

      if (this.rootChart.chartCursor) {
        this.rootChart.chartCursor.showCursorAt(date);
      }
    }

  }

  @autobind
  checkMouseLeave() {
    return this.props.hoverDateIndex != this.props.activeDateIndex

  }

  @autobind
  checkChangeGrapItemStyle(prevProps) {
    const {hoverDateIndex, activeDateIndex} = this.props;
    if (hoverDateIndex == null || activeDateIndex == null || prevProps.hoverDateIndex == hoverDateIndex) {
      return false;
    }

    return true;
  }

  @autobind
  checkTrendApiChanged(prevProps) {
    const {trendApiStatus} = this.props;
    return prevProps.trendApiStatus != trendApiStatus && trendApiStatus == InitStatus.INIT_SUCCESS;
  }


  @autobind
  animateAgain() {
    if (this.rootChart) {
      this.rootChart.animateAgain();
    }
  }


  @autobind
  animationFinished(e) {
    if (this.rootChart) {
      this.changeActiveCategory((this.rootChart.dataProvider.length - 1), true);
    }
  }


  @autobind
  changeActiveCategory(index) {
    if (this.rootChart == null || this.rootChart.dataProvider[index] == undefined || this.rootChart.chartCursor == undefined) return;

    const date = this.getTimestampByIndex(index);
    this.props.handleSetActiveDateIndex(index);
    this.props.handleSetHoverDateIndex(index);
    this.props.handleSetActiveDate(moment(date).format(this.defaultFormat));
    this.changeStyleAndCursor(index);   // cursor, style변경

  }

  @autobind
  changeStyleAndCursor(index) {
    const date = this.getTimestampByIndex(index);
    this.rootChart.chartCursor.showCursorAt(date);                   // cursor 변경
    this.changeGraphItemStyle(index, "over");                        // opaticy 변경
  }


  @autobind
  graphDataChangeEvent(e) {
    if (e.index == null || isNaN(e.index)) return;

    this.props.handleSetHoverDateIndex(e.index);
  }

  @autobind
  getTimestampByIndex(index) {
    if (this.rootChart.dataProvider && this.rootChart.dataProvider[index]) {
      return this.rootChart.dataProvider[index].timestamp;
    }

    return null;
  }


  @autobind
  changeGraphItemStyle(index, eventType) {
    if (index != undefined && index != null) {
      let chartElement = ReactDOM.findDOMNode(this.chart);
      const {activeDateIndex} = this.props;

      try {
        this.chartList.map((name) => {
          let element = chartElement.getElementsByClassName(name);
          let columns = element[0].querySelectorAll(".amcharts-graph-column-front");

          for (let columnIdx = 0; columnIdx < columns.length; columnIdx++) {
            // active 선택된 그래프는 변경하지 않는다.
            if (activeDateIndex == columnIdx) continue;
            columns[columnIdx].setAttribute("bar-status", "");
            columns[columnIdx].setAttribute("width", "5");
            columns[columnIdx].setAttribute("x", "0.5");
          }
          if (eventType == "over") {
            columns[index].setAttribute("bar-status", "hover");
            columns[index].setAttribute("width", "7");
            columns[index].setAttribute("x", "-0.5");
          }
        });
      }
      catch (exception) {
        console.log('error', exception);
      }
    }
  }


  render() {
    const {graphStyle, activeDateType, config, dataProvider, maxCount, trendApiStatus} = this.props;
    const changedMaxCount = (maxCount > 0) ? maxCount + (maxCount * 0.1) : 0;
    const graphConfig = Object.assign({}, config, {
      valueAxes: [{...config.valueAxes[0], maximum: changedMaxCount}],
      dataProvider: dataProvider
    });

    const finishedCallApi = trendApiStatus == InitStatus.INIT_SUCCESS;
    return (
      <Fragment>
        <If condition={finishedCallApi}>
          <div className="box_graph_type1" style={{margin: "0 auto"}}>
            <AmCharts.React
              style={graphStyle}
              className={`line_chart ${activeDateType}`}
              options={graphConfig}
              ref={element => (this.chart = element)}
            />
          </div>
        </If>
      </Fragment>
    );
  }
}

export default GraphColumn;
